/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class SspAPI {

  /**
   * Method that returns a list of ssps
   * @param offset
   * @param limit
   * @param search
   * @param match
   * @param orderby
   * @param comparator
   * @param id
   * @param isActive
   * @param isDoohAudienceMultiplier
   * @param isPublic
   * @returns any Default Response
   * @throws ApiError
   */
  public static getApiSspList(
    offset?: number,
    limit?: number,
    search?: string,
    match: 'exact' | 'contains' | 'starts_with' | 'ends_with' | 'not' = 'starts_with',
    orderby?: Array<string>,
    comparator?: Array<string>,
    id?: Array<number>,
    isActive?: boolean,
    isDoohAudienceMultiplier?: boolean,
    isPublic: boolean = true,
  ): CancelablePromise<Array<{
    id: number;
    name: string;
    media_fee_ratio: number;
    auth_hash: string;
    currency_id: string;
    is_active: boolean;
    is_logging: boolean;
    is_bidswitch: boolean;
    is_dooh_audience_multiplier: boolean;
    is_dooh_html5: boolean;
    is_consent_safe: boolean;
    traffic_ratio: number;
    is_billing_with_nurl: boolean;
    logging_ratio: number;
    dooh_publisher_name_path: string | null;
    dooh_publisher_url_path: string | null;
    dooh_screen_address_path: string | null;
    dooh_screen_id_path: string | null;
    dooh_screen_name_path: string | null;
    dooh_venue_type_code: 'openrtb3' | 'openooh' | 'dmi' | null;
    dooh_venue_type_path: string | null;
    is_public: boolean;
    default_deal_id: number | null;
    bid_ratio: number;
    endpoint: string;
  }>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/ssp/list',
      query: {
        'offset': offset,
        'limit': limit,
        'search': search,
        'match': match,
        'orderby': orderby,
        'comparator': comparator,
        'id': id,
        'is_active': isActive,
        'is_dooh_audience_multiplier': isDoohAudienceMultiplier,
        'is_public': isPublic,
      },
    });
  }

  /**
   * Method that returns a particular ssp
   * @param id
   * @returns any Default Response
   * @throws ApiError
   */
  public static getApiSsp(
    id: number,
  ): CancelablePromise<{
    id: number;
    name: string;
    media_fee_ratio: number;
    auth_hash: string;
    currency_id: string;
    is_active: boolean;
    is_logging: boolean;
    is_bidswitch: boolean;
    is_dooh_audience_multiplier: boolean;
    is_dooh_html5: boolean;
    is_consent_safe: boolean;
    traffic_ratio: number;
    is_billing_with_nurl: boolean;
    logging_ratio: number;
    dooh_publisher_name_path: string | null;
    dooh_publisher_url_path: string | null;
    dooh_screen_address_path: string | null;
    dooh_screen_id_path: string | null;
    dooh_screen_name_path: string | null;
    dooh_venue_type_code: 'openrtb3' | 'openooh' | 'dmi' | null;
    dooh_venue_type_path: string | null;
    is_public: boolean;
    default_deal_id: number | null;
    bid_ratio: number;
    endpoint: string;
  }> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/ssp/{id}',
      path: {
        'id': id,
      },
    });
  }

  /**
   * Method that creates a new ssp
   * @param requestBody
   * @returns any Default Response
   * @throws ApiError
   */
  public static postApiSsp(
    requestBody: {
      id?: number;
      name: string;
      media_fee_ratio?: number;
      auth_hash: string;
      currency_id?: string;
      is_active?: boolean;
      is_logging?: boolean;
      is_bidswitch?: boolean;
      is_dooh_audience_multiplier?: boolean;
      is_dooh_html5?: boolean;
      is_consent_safe?: boolean;
      traffic_ratio?: number;
      is_billing_with_nurl?: boolean;
      logging_ratio?: number;
      dooh_publisher_name_path?: string | null;
      dooh_publisher_url_path?: string | null;
      dooh_screen_address_path?: string | null;
      dooh_screen_id_path?: string | null;
      dooh_screen_name_path?: string | null;
      dooh_venue_type_code?: 'openrtb3' | 'openooh' | 'dmi' | null;
      dooh_venue_type_path?: string | null;
      is_public?: boolean;
      default_deal_id?: number | null;
    },
  ): CancelablePromise<{
    id: number;
    name: string;
    media_fee_ratio: number;
    auth_hash: string;
    currency_id: string;
    is_active: boolean;
    is_logging: boolean;
    is_bidswitch: boolean;
    is_dooh_audience_multiplier: boolean;
    is_dooh_html5: boolean;
    is_consent_safe: boolean;
    traffic_ratio: number;
    is_billing_with_nurl: boolean;
    logging_ratio: number;
    dooh_publisher_name_path: string | null;
    dooh_publisher_url_path: string | null;
    dooh_screen_address_path: string | null;
    dooh_screen_id_path: string | null;
    dooh_screen_name_path: string | null;
    dooh_venue_type_code: 'openrtb3' | 'openooh' | 'dmi' | null;
    dooh_venue_type_path: string | null;
    is_public: boolean;
    default_deal_id: number | null;
    bid_ratio: number;
    endpoint: string;
  }> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/ssp',
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * Method that updates a particular ssp
   * @param requestBody
   * @returns any Default Response
   * @throws ApiError
   */
  public static putApiSsp(
    requestBody: {
      id: number;
      name?: string;
      media_fee_ratio?: number;
      auth_hash?: string;
      currency_id?: string;
      is_active?: boolean;
      is_logging?: boolean;
      is_bidswitch?: boolean;
      is_dooh_audience_multiplier?: boolean;
      is_dooh_html5?: boolean;
      is_consent_safe?: boolean;
      traffic_ratio?: number;
      is_billing_with_nurl?: boolean;
      logging_ratio?: number;
      dooh_publisher_name_path?: string | null;
      dooh_publisher_url_path?: string | null;
      dooh_screen_address_path?: string | null;
      dooh_screen_id_path?: string | null;
      dooh_screen_name_path?: string | null;
      dooh_venue_type_code?: 'openrtb3' | 'openooh' | 'dmi' | null;
      dooh_venue_type_path?: string | null;
      is_public?: boolean;
      default_deal_id?: number | null;
    },
  ): CancelablePromise<{
    id: number;
    name: string;
    media_fee_ratio: number;
    auth_hash: string;
    currency_id: string;
    is_active: boolean;
    is_logging: boolean;
    is_bidswitch: boolean;
    is_dooh_audience_multiplier: boolean;
    is_dooh_html5: boolean;
    is_consent_safe: boolean;
    traffic_ratio: number;
    is_billing_with_nurl: boolean;
    logging_ratio: number;
    dooh_publisher_name_path: string | null;
    dooh_publisher_url_path: string | null;
    dooh_screen_address_path: string | null;
    dooh_screen_id_path: string | null;
    dooh_screen_name_path: string | null;
    dooh_venue_type_code: 'openrtb3' | 'openooh' | 'dmi' | null;
    dooh_venue_type_path: string | null;
    is_public: boolean;
    default_deal_id: number | null;
    bid_ratio: number;
    endpoint: string;
  }> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/api/ssp',
      body: requestBody,
      mediaType: 'application/json',
    });
  }

}
